import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { TweenMax, Quint } from 'gsap';
import { AppEventDispatcher } from '../../../../utils/AppEventDispatcher';
import { InvestmentsSimulationEventType } from '../investments-simulation.event.type';
import { InvestmentOption } from '../../models/investmentOption';
import { Simulation } from '../../models/simulation';
import { SharedService } from '../../../../shared/shared.service';
import { EventTypes } from '../../../../shared/EventTypes';
import { Auth } from '../../../../autentication/Auth';

@Component({
	selector: 'app-investments-options',
	templateUrl: './investments-options.component.html',
	styleUrls: ['./investments-options.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class InvestmentsOptionsComponent implements OnInit, OnDestroy {

	@Input() simulationData: Simulation;

	private view = '[data-component="investments-options"]';

	public active = false;
	public investmentsOptions: Array<InvestmentOption>;
	public noBalanceEnough = false;

	constructor(private sharedService: SharedService) { }

	ngOnInit() {
		AppEventDispatcher.listen(InvestmentsSimulationEventType.STEPS.INVESTMENTS_OPTIONS, data => {
			this.preload(true);

			this.sharedService.getBalance().subscribe((dataBalance: any) => {

				if (data.show) {
					this.active = true;
					this.show();
				}

				this.preload(false);

				if (dataBalance.Retorno.SaldoSaque < data.valueToInvest) {
					this.noBalanceEnough = true;
				}

			}, error => {
				this.preload(false);
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="investments-options"] .content', show: active, delay: delay });
	}

	show() {
		this.investmentsOptions = this.simulationData.investmentOptionsList;

		const interval = setInterval(() => {

			if ($('.invest-option').length > 0) {
				const containerHeight = this.getStepHeight();

				TweenMax.to('.steps-container', .8, { height: $(this.view).outerHeight(), ease: Quint.easeOut });
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });

				clearInterval(interval);
			}

		}, 10);
	}

	onDetailOption(option) {
		this.simulationData.option = option;
		AppEventDispatcher.dispatch(InvestmentsSimulationEventType.STEPS.INVESTMENTS_CONFIRMATION, { show: true });

		TweenMax.to(this.view, .8, {
			left: '-100%', ease: Quint.easeOut, onComplete: () => {
				this.active = false;
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(InvestmentsSimulationEventType.STEPS.INVESTMENTS_OPTIONS);
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-simulation/investments-options/investments-options.component.ts